import React from "react";
import { Icon , IconProps } from "@chakra-ui/react";

const KeyboardArrowUpIcon = (props: IconProps) => (
  <Icon viewBox="0 -960 960 960" boxSize={6} fill="currentColor" {...props}>
    <path d="M480-528 296-344l-56-56 240-240 240 240-56 56-184-184Z"/>
  </Icon>
);

export default KeyboardArrowUpIcon;
